import React from 'react';
import { FormInput } from 'react-form';
import { Checkbox } from 'material-ui';

export default ( { field, ...rest } ) => {
  return (
    field ?
      <FormInput field={field}>
        {( { setValue, getValue, setTouched } ) => {
          return (
            <Checkbox
              labelPosition="left"
              checked={getValue() || false}
              onCheck={event => setValue( event.target.checked )}
              onBlur={() => setTouched()}
              {...rest}
            />
          )
        }}
      </FormInput> :
      <Checkbox
        labelPosition="left"
        {...rest}
      />
  )
}



// WEBPACK FOOTER //
// ./components/FormElements/Checkbox/index.js